import { type Color } from 'theme/theme';

export const styleColor: Record<
  FlashMessageType['type'],
  {
    bg: Color;
    color: Color;
  }
> = {
  success: {
    bg: 'brandGreen',
    color: 'white',
  },
  info: {
    bg: 'lightContentGrey',
    color: 'white',
  },
  warn: {
    bg: 'brandYellow',
    color: 'mediumContentGrey',
  },
  error: {
    bg: 'alertRed',
    color: 'white',
  },
};
